<script>
export default {
    name: '404',
    mounted() {
        this.redirect()
    },
    methods: {
        redirect() {
            window.open('/admin', '_self')
        }
    }
}
</script>